import React from 'react';
import { useTranslation } from 'react-i18next';

// The ONE drawer footer (the only place a `dr-foot` is written): Close on the LEFT as a bordered .btn, `start` = secondary
// actions that stay beside it, spacer, `secondary` buttons, and the main action right-most as `btn success`
// (use <PrimaryButton/> or className "btn success"). Wraps at narrow widths (shell.css .dr-foot flex-wrap).
export const MAIN_BTN = 'btn success';
export default function DrawerFooter({ onClose, closeLabel, closeDisabled, start, secondary, primary, closeTestId }) {
  const { t } = useTranslation('actions');
  return (
    <div className="dr-foot">
      <button type="button" className="btn" onClick={onClose} disabled={closeDisabled} data-testid={closeTestId}>{closeLabel || t('close')}</button>
      {start}
      <div className="spacer" />
      {secondary}
      {primary}
    </div>
  );
}
